import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { api } from '../../../models/api-url.model';
import { ApiService } from '../api';

@Injectable({
  providedIn: 'root',
})
export class LineItemService {
  private readonly apiService = inject(ApiService);

  getDisconnectReasons(): Observable<string[]> {
    return this.apiService.get(`${api.lineItemsURL}/disconnect-reasons`);
  }
}

